export var LevelSubmissionSort;
(function (LevelSubmissionSort) {
    LevelSubmissionSort["ATTEMPTS"] = "attempts";
    LevelSubmissionSort["DATE_ADDED"] = "dateAdded";
    LevelSubmissionSort["ENJOYMENT"] = "enjoyment";
    LevelSubmissionSort["RATING"] = "rating";
    LevelSubmissionSort["PROGRESS"] = "progress";
    LevelSubmissionSort["REFRESH_RATE"] = "refreshRate";
    LevelSubmissionSort["USERNAME"] = "username";
})(LevelSubmissionSort || (LevelSubmissionSort = {}));
